import { Group, Button, TextInput, TextInputProps, Autocomplete, AutocompleteProps, ComboboxItem } from "@mantine/core";
import { useForm, schemaResolver } from "@mantine/form";
import { ContextModalProps } from "@mantine/modals";
import { z } from 'zod';

interface AutocompleteModalProps {
    initText?: string,
    data?: ComboboxItem[]
    children?: React.ReactNode;
    AutocompleteProps?: AutocompleteProps,
    confirmLabel?: string,
    zodString?: z.ZodString,
    onConfirm?: (value: string) => void;
}
export const AutocompleteModal = ({
    context,
    id,
    innerProps,
}: ContextModalProps<AutocompleteModalProps>) => {
    const schema = z.object({
        text: innerProps.zodString ?? z.string()
    });
    const form = useForm({
        validate: schemaResolver(schema),
        initialValues: {
            text: innerProps.initText
        },
    });
    return <>
        {innerProps.children}
        <form onSubmit={form.onSubmit((values) => {
            innerProps.onConfirm?.(values.text ?? "");
            context.closeModal(id)
        })}>
            <Autocomplete
                data={innerProps.data?.map(x => x.label)}
                value={
                    form.values.text
                }
                onChange={(val) => {
                    const match = innerProps.data?.find((o) => o.label === val);
                    if (match) {
                        form.setFieldValue("text", match.value);
                    } else {
                        form.setFieldValue("text", val);
                    }
                }}
            />
            <Group justify="flex-end" mt="md">
                <Button type="submit">{innerProps.confirmLabel || "確認"}</Button>
            </Group>
        </form>
    </>
}